"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeRow = exports.getBaseFieldConfigMap = exports.getHeaderRenameFunction = exports.getSanitizedCsvData = void 0;
const helpers_1 = require("./helpers");
var helpers_2 = require("./helpers");
Object.defineProperty(exports, "getSanitizedCsvData", { enumerable: true, get: function () { return helpers_2.getSanitizedCsvData; } });
const getHeaderRenameFunction = (sanitizeFieldNames) => {
    return (rawHeader) => (0, helpers_1.getSanitizedFieldName)(rawHeader, sanitizeFieldNames);
};
exports.getHeaderRenameFunction = getHeaderRenameFunction;
const getBaseFieldConfigMap = ({ baseFields, sanitizeFieldNames, }) => baseFields.reduce((configMap, baseField) => {
    const sanitizedField = (0, helpers_1.getSanitizedFieldName)(baseField.field, sanitizeFieldNames);
    // eslint-disable-next-line no-param-reassign
    configMap[sanitizedField] = Object.assign(Object.assign({}, baseField), { field: sanitizedField });
    return configMap;
}, {});
exports.getBaseFieldConfigMap = getBaseFieldConfigMap;
const sanitizeRow = ({ csvRow, lineNumber, baseFieldConfigMap, }) => {
    // TODO: @sachinr4
    // Add error handling here (throw for now)
    const sanitizedRowData = (0, helpers_1.getSanitizedDataTapeRowData)(csvRow, lineNumber, baseFieldConfigMap);
    return sanitizedRowData;
};
exports.sanitizeRow = sanitizeRow;
//# sourceMappingURL=stream.js.map